export * from './postInstall';
export { default } from './postInstall';
